module.exports = __webpack_public_path__ + "static/media/whiteChip.bed1767e.svg";